module.exports = __webpack_public_path__ + "img/bg8.11b7a09f.png";